import React from "react";
import "../App.css";
import Fire from "../config/Fire";
import Aux from "../utils/AuxFunctions";
import { withMyDataContext } from "../context/DataProvider";
import Loader from "../utils/Utilities/Loader"
import ChevronLeftIcon from "mdi-react/ChevronLeftIcon";
import ArrowRight from "mdi-react/ArrowRightCircleIcon"
import moment from "moment"
import ChatMessage from "../utils/Messages/ChatMessage";
import TextareaAutosize from 'react-textarea-autosize';
import Colors from "../utils/Colors";

const LIMIT = 20;

class ViewMessage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            text: "",
            user: null,
            message: null,
            messagesData: [],
            lastVisible: null,
            finished: false,
            loading: false,
            loadingMessageInfo: false,
            noMessageFound: false,
            lastMessage:{},
        }
    }

    chatContainer = React.createRef();

    componentDidMount = async () => {
        try {
            // this.getAllData(true);
            this.getAllMessages(true)
            if (this.props.location.state?.message) {
                this.setState({ message: this.props.location.state.message })
                this.updateReadMessage(this.props.location.state.message)
                if (this.props.location.state?.user) {

                    this.setState({ user: this.props.location.state.user })
                } else {
                    const found = this.props.location.state.message?.users.find(user => user !== Fire.shared.uid)
                    this.getUserInfo(found)
                }
            } else {
                const messageInfo = await this.getMessageInfo()
                if (messageInfo) {
                    this.updateReadMessage(messageInfo)
                    this.createScrollListener()
                    if (this.props.location.state?.user) {
                        this.setState({ user: this.props.location.state.user })
                    } else {
                        const found = messageInfo.message?.users.find(user => user !== Fire.shared.uid)
                        this.getUserInfo(found)
                    }
                } else {

                }
            }

            if (this.props.location.state?.user) {
                this.setState({ user: this.props.location.state.user })
            } else {
                const messageInfo = await this.getMessageInfo();
                if (messageInfo) {
                    this.createScrollListener()
                    const found = messageInfo?.users.find(user => user !== Fire.shared.uid)
                    this.getUserInfo(found)
                } else {
                    this.setState({ noMessageFound: true })
                }

            }




        } catch (error) {
            Aux.handleError(error)
        }
    }

    componentWillUnmount = () => {
        this.props.myDataProvider.setNewCurrentMessage("")
        if (this.messagesListener) {
            this.messagesListener();
        }
    }

    componentDidUpdate(prevProps, prevState) {

        if(prevProps.myDataProvider.newMessage!==this.props.myDataProvider.newMessage){
            this.props.myDataProvider.setNewMessage(false)
        }
    }

    createScrollListener = () => {
        try {
            var el = document.getElementById("scrollableMessageBox")
            if (el) {
                el.addEventListener('scroll', (event) => {
                    if (event.target.scrollTop === 0) {
                        if (!this.state.finished && !this.state.loading) {
                            this.getAllMessages(false)
                        }
                    }
                }, false);
            }
        } catch (error) {
            Aux.handleError(error)
        }
    }

    getMessageInfo = async () => {
        try {
            this.setState({ loadingMessageInfo: true })
            let messageQuery = await Fire.shared.firestore.collection('chats')
                .doc(this.props.match.params.message).get()
            if (messageQuery.exists) {
                this.setState({ message: messageQuery.data(), loadingMessageInfo: false })
                return messageQuery.data()
            } else {
                this.setState({ loadingMessageInfo: false, noMessageFound: true })
            }

        } catch (error) {
            Aux.handleError(error)
            this.setState({ loadingMessageInfo: false, noMessageFound: true })
        }
    }

    getUserInfo = async (uid) => {
        if (!uid)
            return
        try {

            this.setState({ loadingUser: true })
            let userQuery = await Fire.shared.firestore.collection("users").doc(uid).get();
            if (userQuery.exists) {
                this.setState({ user: userQuery.data(), loadingUser: false })
            } else {
                this.setState({ noUserFound: true, loadingUser: false })
            }

        } catch (error) {
            Aux.handleError(error)
            this.setState({ loadingUser: false, noUserFound: true, })
        }
    }

    updateReadMessage = (message, lastMessage) => {
        try {
            this.props.myDataProvider.setNewCurrentMessage(this.props.match.params.message)
            if(lastMessage){
                if(lastMessage.from !== Fire.shared.uid){
                        Fire.shared.firestore.collection('chats')
                            .doc(this.props.match.params.message).set({
                                lastMessage: {
                                    read: true
                                }
                            }, { merge: true }
                            )
                }
            }else if (message.lastMessage?.from !== Fire.shared.uid) {
                if (!message.lastMessage.read) {
                    Fire.shared.firestore.collection('chats')
                        .doc(this.props.match.params.message).set({
                            lastMessage: {
                                read: true
                            }
                        }, { merge: true }
                        )
                }
            }
        } catch (error) {
            Aux.handleError(error)
        }
    }

    scrollToBottom = () => {
        if (this.chatContainer.current) {
            const scroll =
                this.chatContainer.current.scrollHeight -
                this.chatContainer.current.clientHeight;
            this.chatContainer.current.scrollTo(0, scroll);

        }
    };

    goToUser = () => {
        this.props.history.push(`/user/${this.state.user.username}`)
        //this.props.navigation.navigate(`/post/${this.state.post.id}`)
    }

    ChatMessage = (props) => {
        const { text, from } = props.message;
        const imSender = from === Fire.shared.uid ? true : false;
        if (props.message.system) {
            return (
                <div style={{ display: "flex", margin: "5px 0", width: "auto", alignSelf: "center" }}>
                    <span style={{ color: Colors.softText }}>{text}</span>
                </div>
            )
        } else if (imSender) {
            return (
                <div style={{ display: "flex", backgroundColor: "lightblue", margin: "5px 0", padding: "5px 10px", borderRadius: 5, maxWidth: "70%", alignSelf: "end" }}>
                    <span>{text}</span>
                </div>
            )
        } else {
            return (
                <div style={{ display: "flex", }}>
                    {/* {this.state.user ? 
                        <div style={{marginRight:5, marginTop:10}}>
                        {Aux.showAvatar(20, this.state.user.avatar, this.state.user.username || "Unknown")  }
                        </div>: null} */}
                    <div style={{ display: "flex", backgroundColor: "lightgreen", margin: "5px 0", padding: "5px 10px", borderRadius: 5, maxWidth: "70%", alignSelf: "start" }}>
                        <span>{text}</span>
                    </div>
                    <span style={{ color: Colors.softText, fontSize: 10, margin: 5 }}>{this.getTime(props.message.timestamp)}</span>
                </div>
            )
        }
    }

    getTime = (timestamp) => {
        try {
            if (!timestamp)
                return null
            return moment(timestamp.toDate()).fromNow();
        } catch (error) {
            Aux.handleError(error)
            return null
        }

    }
    goBack = () => {
        try {
            this.props.history.goBack()
        } catch (error) {
            Aux.handleError(error)
        }
    }

    sendMessage = async () => {
        if (!this.state.text)
            return;
        try {
            await Fire.shared.sendSingleMessage(this.props.match.params.message, this.state.text)
            this.setState({ text: "" })
        } catch (error) {
            Aux.handleError(error)
        }
    }

    /* sendMessageOther = async () => {
        if (!this.state.text)
            return;
        try {
            const found = this.state.message?.users.find(user => user !== Fire.shared.uid)
            await Fire.shared.sendSingleMessage(this.props.match.params.message, this.state.text, found)
            this.setState({ text: "" })
        } catch (error) {
            Aux.handleError(error)
        }
    } */

    messagesListener = null;

    createMessagesListener = async (ref, start) => {
        try {
            var query = ref
            /* if (start && start.data().timestamp) {
                query = query.startAt(start)
            } */
            query = query.endAt(start)
            this.messagesListener = query.onSnapshot({ includeMetadataChanges: false }, (snap) => {        // append new messages to message array

                snap.docChanges().forEach((doc) => {
                    let newMessage = null;
                    if (doc.doc.data().timestamp) {
                        newMessage = doc.doc.data();
                        newMessage.id = doc.doc.id;
                        let messages = this.state.messagesData;
                        messages = messages.filter(x => x.id !== newMessage.id)
                        this.setState({ messagesData: [...messages, newMessage] })
                        this.scrollToBottom()
                        this.updateReadMessage(this.state.message, newMessage)
                        /* if (doc.type === "modified") {
                            this.setState({ gotNewMessage: true })
                        } */
                    }
                })
            })
        } catch (error) {
            Aux.handleError(error)
        }
    }

    getAllMessages = async (isStart) => {
        var currentScrollPos = 0
        if (this.chatContainer.current)
            currentScrollPos = this.chatContainer.current.scrollHeight - this.chatContainer.current?.scrollTop
        try {
            let lastVisible = null;
            this.setState({ loading: true })
            if (isStart) {
                this.setState({
                    messagesData: [],
                    finished: false,
                    lastVisible: null,
                });
            } else {
                lastVisible = this.state.lastVisible
            }
            let initialQuery = Fire.shared.firestore.collection('chats')
                .doc(this.props.match.params.message)
                .collection("messages")
                .orderBy('timestamp', 'desc')

            if (lastVisible) {
                initialQuery = initialQuery.startAfter(lastVisible);
            }

            let snapshot = await initialQuery.limit(LIMIT).get();
            if (snapshot && !snapshot.empty) {
                if (snapshot.length < LIMIT || snapshot.empty) {
                    this.setState({ finished: true })
                }

                let data = snapshot.docs.map(document => {
                    const doc = document.data();
                    doc.id = document.id;
                    return doc;
                });
                let reversedData = data.sort().reverse()
                this.setState({
                    //messagesData: [ ...reversedData, ...this.state.messagesData,],
                    messagesData: [...reversedData, ...this.state.messagesData,],
                    lastVisible: snapshot.docs[snapshot.docs.length - 1],
                    loading: false,
                });
                if (this.chatContainer.current)
                    this.chatContainer.current.scrollTop = this.chatContainer.current?.scrollHeight - currentScrollPos;
                if (isStart) {
                    this.createMessagesListener(initialQuery, snapshot.docs[0])
                }
            } else {
                this.setState({ finished: true, loading: false })
            }

        } catch (error) {
            Aux.handleError(error)
            this.setState({ loading: false })
        }
    }

    render() {

        return (
            <div style={{ width: "100%", }}>
                <section className="container">
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <div className="reversed-button-hover" style={{ display: "flex", alignItems: "center", marginBottom: 20 }} onClick={this.goBack}>
                            <ChevronLeftIcon style={{ marginRight: 5 }}></ChevronLeftIcon>
                            {this.state.user ?
                                <div style={{ display: "flex" }}>
                                    <h3 style={{ marginLeft: 10 }}>{this.state.user.username}</h3>
                                </div>
                                : <h3>Message</h3>}
                            {/* <h2>{this.state.user}</h2> */}
                        </div>
                        <div>
                            {this.state.user ?
                                <div className="reversed-button-hover" onClick={this.goToUser}>
                                    {Aux.showAvatar(30, this.state.user.avatar, this.state.user.username || "Unknown")}
                                </div>
                                : null}
                        </div>
                    </div>
                    {/* <span onClick={this.scrollToBottom}>More</span> */}

                    <div ref={this.chatContainer} id="scrollableMessageBox" style={{ display: "flex", flexDirection: "column", overflowY: "scroll", height: 300, marginBottom: 10, borderWidth: 1, borderColor: "#ccc", borderStyle: "solid" }}>
                        {this.state.loadingMessageInfo ?
                            <Loader style={{ marginTop: 10 }}></Loader>
                            : this.state.noMessageFound ?
                                <div style={{ display: "flex", justifyContent: "center" }} >
                                    <span>No Chat found...</span>
                                </div> :
                                this.state.loading ?
                                    <Loader style={{ marginTop: 10 }}></Loader> : null}

                        {!this.state.loading && this.state.messagesData.length <= 0 && !this.state.noMessageFound?
                            <div style={{marginTop:10}}><span >No messages yet</span> </div>:
                            this.state.messagesData.map((item, index) => (
                                <ChatMessage message={item} key={item.id + index} />
                            ))}

                        {/* <div ref={el => this.messagesEnd = el}></div> */}

                    </div>
                    {this.props.myDataProvider.user && !this.state.noMessageFound ?
                        <div style={{ display: "flex", borderWidth: 1, borderColor: "#ccc", borderStyle: "solid", alignItems: "center", padding: "0px 10px" }}>
                            {Aux.showAvatar(30, this.props.myDataProvider.user.avatar, this.props.myDataProvider.user.username || "Unknown",)}


                            <TextareaAutosize placeholder="Write your message..." maxRows={4} className="text-area-remove-border"
                                style={{ border: "none", flex: 1, padding: 5, marginLeft: 10, resize: "none", backgroundColor: "transparent" }}
                                value={this.state.text}
                                /* onChange={this.handleChange} */
                                onChange={(e) => {
                                    this.setState({ text: e.target.value });
                                }} />
                            <div className="button-hover" style={{ margin: "10px 0" }} onClick={this.sendMessage}>
                                <ArrowRight color={Colors.mainColor}></ArrowRight>
                            </div>
                            {/* <div className="button-hover" style={{ margin: "10px 0" }} onClick={this.sendMessageOther}>
                                <ArrowLeft color={Colors.mainColor}></ArrowLeft>
                            </div> */}
                        </div>
                        : null}

                </section>
            </div>
        );
    }
}

export default withMyDataContext(ViewMessage);
